import { gql } from "@/gql/__generated__";
import { useQuery } from "@apollo/client";

export const SUBSCRIPTION_OFFER = gql(`
  query subscriptionOffer($subscriptionOfferId: ID!) {
    subscriptionOffer(subscriptionOfferId: $subscriptionOfferId) {
      ... on SubscriptionOffer {
        __typename
        id
        message
        status
        expiresAt
        payment {
          monthlyPriceUSD
          trialDays
        }
        app {
          __typename
          id
          slug
          displayName
          description
        }
        offeringOrganization {
          __typename
          id
          name
        }
      }
      ... on SubscriptionOfferNotFound {
        __typename
        id
      }
    }
  }
`);

export function useSubscriptionOffer(subscriptionOfferId: string) {
  const { data, ...rest } = useQuery(SUBSCRIPTION_OFFER, {
    variables: { subscriptionOfferId }
  });

  return { ...rest, data: data?.subscriptionOffer };
}
